var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21H21.0189V10.2415C21.0189 9.72923 20.9081 9.22308 20.694 8.75771C20.48 8.29234 20.1679 7.87877 19.779 7.54536L12.9823 1.73341C12.4345 1.26031 11.7349 1 11.0111 1C10.2873 1 9.58762 1.26031 9.03985 1.73341L2.24311 7.54536C1.85366 7.87846 1.54092 8.2919 1.32634 8.75729C1.11176 9.22267 1.00043 9.72898 1 10.2415V21ZM2.93731 10.2415C2.9373 10.0083 2.9878 9.77784 3.08534 9.56603C3.18289 9.35422 3.32516 9.16606 3.50236 9.01449L10.2991 3.20254C10.4966 3.03232 10.7487 2.93869 11.0095 2.93869C11.2702 2.93869 11.5223 3.03232 11.7198 3.20254L18.5165 9.01449C18.6938 9.16606 18.836 9.35422 18.9336 9.56603C19.0311 9.77784 19.0816 10.0083 19.0816 10.2415V19.0627H2.93731V10.2415Z",
    fill: "#8E8E93",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8531 14.8652H6.16656V16.8025H15.8531V14.8652Z",
    fill: "#8E8E93",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.4aa7dfe96c971319a74506ab13065a04.svg";
export { ForwardRef as ReactComponent };